<template>

<div class="container" style="padding-top: 30px;">

  <BlockUI v-if="blockUI" message="Prosimo počakajte trenutek..."
           url="/images/loading-spinner.svg"></BlockUI>

  <module_customer_address
    ref="module_customer_address"
    :model="model"
    :schema="customerTabSchema"
  ></module_customer_address>

  <!--<module_guests-->
  <!--ref="module_guests"-->
  <!--:model="model"-->
  <!--:schema="customerTabSchema"-->
  <!--&gt;</module_guests>-->
  <module_customer_business
    ref="module_customer_business"
    :model="model"
    :schema="paymentMethodsTabSchema"
  ></module_customer_business>
  <module_payment_methods
    ref="module_payment_methods"
    :model="model"
    :payment_method="model.payment_method"
    :schema="paymentMethodsTabSchema"
    :env="env"
    :checkout="checkout"
    :submit_url="submit_url"
  ></module_payment_methods>
  <module_terms
    ref="module_terms"
    :model="model"
    :schema="paymentMethodsTabSchema"
  ></module_terms>

  <module_tracking
    ref="module_tracking"
    :model="model"
    :checkout="checkout"
  ></module_tracking>

  <module_affiliate
    ref="module_affiliate"
    :model="model"
  ></module_affiliate>


  <div class="row">

    <div class="col-md-8 col-md-offset-2">

      <savina-guarantee-bs3></savina-guarantee-bs3>

      <module_coupon
        ref="module_coupon"
        :model="model"
        :schema="paymentMethodsTabSchema"
        :checkout="checkout"
      ></module_coupon>

      <div class="panel panel-default">


        <form-wizard
          title="Prijavnica"
          subtitle=" "
          shape="tab"
          @on-complete="onComplete"
          @on-change="onChange"
          color="#3a3d3f"
          error-color="#a94442"
          ref="prijavnica"
          id="checkout"
        >


          <tab-content v-if="displayFirstTab" title="Delavnice" :before-change="validateDatesData"
          >


            <div class="row">
              <div class="form-group col-sm-12" v-if="products.length">
                <h4 class="text-center"
                >{{ welcomeText }}
                  <br>

                  <span v-if="products.length > 1 && checkout.enable_discounts == true">
                                            V
                                            primeru, da se prijavite na 2 ali več delavnic hkrati, vam
                                            priznamo
                                            10%
                                            popust!
                                            :) </span></h4>

                <div class="custom-rc-warning text-center"
                     style="margin-top: 40px;" v-if="checkout.description"
                     v-html="checkout.description">

                </div>

                <div id="products" class="custom-rc products">

                  <div v-for="product in products" class="custom-rc-warning">
                    <input :id="product.id" type="checkbox" v-model="model.products"
                           :value="product" class="products"
                           v-on:change="changeProduct(product)"/>
                    <label :for="product.id">{{ product.name }} <span
                      class="red-text">{{ product.extras_json.red_text }}</span></label>
                  </div>

                </div>
              </div>


              <div class="form-group col-sm-12" v-if="waitlists.length">
                <h4 class="text-center">Spodnje delavnice so žal že razprodane. Lahko se
                  prijavite v čakalno listo in v primeru, da se sprosti mesto, vas
                  bomo kontaktirali. </h4>

                <div id="waitlists" class="custom-rc">
                  <div v-for="product in waitlists" class="custom-rc-warning">
                    <input :id="product.id" type="checkbox" v-model="model.waitlists"
                           :value="product" class="products"
                           v-on:change="changeWaitlist(product)"
                    />
                    <label :for="product.id">{{ product.name }} <span
                      class="red-text">{{ product.extras_json.red_text }}</span></label>

                  </div>
                </div>
              </div>
            </div>

          </tab-content>

          <tab-content title="Podatki" :before-change="validateCustomerData">

            <div class="row">
              <vue-form-generator :model="model"
                                  :schema="customerTabSchema"
                                  :options="formOptions"
                                  ref="customerDataForm"
              >
              </vue-form-generator>

              <module_dna_codes
                ref="module_dna_codes"
                :model="model"
                :customer_schema="customerTabSchema"
                :payment_schema="paymentMethodsTabSchema"
              ></module_dna_codes>
            </div>

          </tab-content>

          <tab-content title="Način plačila" :before-change="validatePaymentMethods">

            <vue-form-generator :model="model"
                                :schema="paymentMethodsTabSchema"
                                :options="formOptions"
                                ref="paymentMethodsForm"
            >
            </vue-form-generator>

            <module_customer_data_confirmation
              ref="module_customer_data_confirmation"
              :model="model"
              :checkout="checkout"
            >
            </module_customer_data_confirmation>

          </tab-content>


          <div id="orderSummary">

            <div class="table">
              <div class="row header">
                <div class="col-sm-9">{{productTypeName}}</div>
                <div class="col-sm-3">Skupni znesek</div>
              </div>
              <hr>
              <div id="items">
                <div class="row item" v-for="product in model.products">
                  <div class="col-sm-9 name">{{product.name}}</div>
                  <div class="col-sm-3 price">{{product.price}}€</div>
                </div>
                <div class="row item" v-for="product in model.waitlists">
                  <div class="col-sm-9 name">{{product.name}}</div>
                  <div class="col-sm-3 price">Čakalna lista</div>
                </div>
              </div>
            </div>


            <div class="quantity" v-if="model.quantity > 1">
              <hr>

              <div class="row quantity">

                <div class="col-sm-3 col-sm-offset-6">
                  Količina
                </div>
                <div class="col-sm-3 text-right number">
                  {{ model.quantity }}
                </div>
              </div>
            </div>


            <div class="totals" v-if="model.price_total > 0">
              <hr>
              <div class="row total">
                <div class="col-sm-3 col-sm-offset-6">
                  Skupni znesek
                </div>
                <div class="col-sm-3 text-right price">
                  {{ model.price_total_without_discount }}€
                </div>
              </div>
              <hr class="total-discount-divider">


              <div class="row discount" v-if="model.price_discount > 0">
                <div class="col-sm-3 col-sm-offset-6">
                  Popust
                </div>
                <div class="col-sm-3 text-right price">
                  {{ model.price_discount }}€
                </div>
              </div>


              <div v-if="multiplePayments">
                <div class="row price_pay_later">
                  <div class="col-sm-3 col-sm-offset-6">
                    Plačate kasneje
                  </div>
                  <div class="col-sm-3 text-right price">
                    {{ model.price_pay_later }}€
                  </div>

                </div>

                <hr>
              </div>


              <div class="row finalTotal">
                <div class="col-sm-3 col-sm-offset-6 title">
                  Za plačilo
                </div>
                <div class="col-sm-3 text-right price">
                  {{ model.price_pay_now}}€
                </div>
              </div>
            </div>
          </div>


          <template slot="footer" slot-scope="props">

          <div class=wizard-footer-left>
            <wizard-button v-if="props.activeTabIndex > 0"
                           @click.native="props.prevTab()">Nazaj
            </wizard-button>
          </div>

          <div class="wizard-footer-right">
            <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()"
                           class="wizard-footer-right">Nadaljuj
            </wizard-button>


            <div v-show="props.isLastStep">

              <wizard-button
                v-if="!isValidForm"
                class="wizard-footer-right finish-button">Izpolnite vsa polja
              </wizard-button>

              <wizard-button v-else-if="model.payment_method === 'paypal'"
                             @click.native="props.nextTab()"
                             class="wizard-footer-right finish-button">
                Oddajte prijavnico (Preusmeritev na Paypal)
              </wizard-button>


              <wizard-button v-else-if="model.payment_method !== 'braintree_paypal'"
                             @click.native="props.nextTab()"
                             class="wizard-footer-right finish-button">Oddajte prijavnico
              </wizard-button>


              <div v-show="isValidForm && model.payment_method === 'braintree_paypal'"
                   id="paypal-button"
                   aria-live="assertive" style=""
                   class="wizard-footer-right finish-button">

              </div>
            </div>

          </div>
          </template>

        </form-wizard>

      </div>
    </div>
  </div>
</div>
</template>

<script>
//    import VueFormGenerator from "vue-form-generator/dist/vfg-core.js";
//
import VueFormWizard from 'vue-form-wizard';

Vue.use(VueFormWizard);

import VueFormGenerator from "vue-form-generator/dist/vfg.js";

Vue.use(VueFormGenerator);

import BlockUI from 'vue-blockui'

Vue.use(BlockUI);

import Multiselect from 'vue-multiselect'

Vue.use(Multiselect);
window.VueMultiselect = Multiselect;


//    import "vue-form-generator/dist/vfg-core.css";  // optional core css additions
//    import 'vue-form-wizard/dist/vue-form-wizard.min.css';


export default {

  props: ["products", "waitlists", "checkout", "braintree_client_token", "enable_coupons", "submit_url", "env"],

  components: { Multiselect },

  data: function () {
    return {


      blockUI: false,

      customValidation: {
        customerData: false,
      },

      model: {
        checkout_id: null,

        order_id: null,
        // totals
        quantity: 1,
        payments: 1,
        price_total_without_discount: 0,
        price_total: 0,
        price_pay_now: 0,
        price_pay_later: 0,
        price_discount: 0,

        // products
        products: [],
        waitlists: [],


        // customer
        customer: {
          first_name: '',
          last_name: '',
          email: '',
          telephone: '',
          //                        **** module_customer_address
          //                        address: "",
          //                        postal_code: "",
          //                        city: "",

          //                        **** module_dna_codes
          //                        birthday_day: "",
          //                        birthday_month: "",
          //                        birthday_year: "",
          //                        birthday_hour: "",
          //                        birthday_minute: ""
        },

        //                    **** module_dna_codes
        //                    additional_codes: true,
        //                    additional_codes_data: [],

        //                    **** module_guests
        //                    guests: false,
        //                    guests_data: {
        //                        first_name: '',
        //                        last_name: '',
        //                        email: '',
        //                        reminders: false,
        //                    }

        //                    **** module_business
        //                    business: false,
        //                    business_data: {
        //                        name: '',
        //                        vat: '',
        //                        address: '',
        //                        postal_code: '',
        //                        city: ''
        //                    }

        //                    **** module_payment_methods
        //                    payment_method: "",
        //                    payment_method_nonce: null,
        //                    payment_method_nonce_type: null,

        //                    **** module_coupon
        //                    coupon: {
        //                        isValid: false,
        //                        code: '',
        //                        discount: 0,
        //                        string: "",
        //                    }


        //                    **** module_terms
        //                    terms: [],


      },
      formOptions: {
        validationErrorClass: "has-error",
        validationSuccessClass: "has-success2",
        validateAfterChanged: true
      },
      customerTabSchema: {
        groups: [
          {
            fields: [{
              type: "input",
              inputType: "text",
              label: "Ime",
              model: "customer.first_name",
              required: true,
              validator: VueFormGenerator.validators.string,
              styleClasses: 'col-sm-6'
            },
              {
                type: "input",
                inputType: "text",
                label: "Priimek",
                model: "customer.last_name",
                required: true,
                validator: VueFormGenerator.validators.string,
                styleClasses: 'col-sm-6'
              },
              {
                type: "input",
                inputType: "text",
                label: "Email",
                model: "customer.email",
                required: true,
                validator: VueFormGenerator.validators.email,
                styleClasses: 'col-sm-6'
              },
              {
                type: "input",
                inputType: "text",
                label: "Telefon",
                model: "customer.telephone",
                required: true,
                validator: VueFormGenerator.validators.string,
                styleClasses: 'col-sm-6'
              },

            ]
          },

        ]
      },
      paymentMethodsTabSchema: {
        groups: []
      },

    }
  },


  mounted() {

    this.selectDateOrWailist();

    // optional
    //            this.$refs.prijavnica.nextTab();
    //            this.$refs.prijavnica.nextTab();

    this.model.checkout_id = this.checkout.id;

    this.$refs.module_customer_address.init();

    this.$refs.module_customer_business.init();

    this.$refs.module_payment_methods.init(this.braintree_client_token);

    if (this.enable_coupons) {
      this.$refs.module_coupon.init();
    }

    this.$refs.module_terms.init();


    if (this.checkout.type === "dna_codes") {
      this.$refs.module_dna_codes.init();
      this.$refs.module_customer_data_confirmation.init();
    } else {
      // this.$refs.module_guests.init();
    }

    this.$refs.module_tracking.init();

    this.$refs.module_affiliate.init();

    if (this.env === 'sandbox') {
      this.loadDemoData();
    }


  }
  ,

  created() {
    Event.$on("prijavnica_update_totals", function () {
      this.updateTotals();
    }.bind(this));

    Event.$on("braintree_paypal_tokenized", function () {
      this.onComplete();
    }.bind(this));


    VueFormGenerator.validators.resources.fieldIsRequired = "To polje je obvezno.";
    VueFormGenerator.validators.resources.invalidEmail = "Prosimo vpišite veljaven email naslov."
  }
  ,

  methods: {


    loadDemoData() {
      this.model.customer.first_name = "Jan";
      this.model.customer.last_name = "Demsar";
      this.model.customer.email = "jan@janDemsar.com";
      this.model.customer.telephone = "05185385";
      this.model.customer.address = "Studeno 5";
      this.model.customer.postal_code = "4229";
      this.model.customer.city = "Zelezniki";
      this.model.customer.birthday_year = 1992;
      this.model.customer.birthday_month = 3;
      this.model.customer.birthday_day = 28;
      this.model.customer.birthday_hour = 4;
      this.model.customer.birthday_minute = 44;


    },
    selectDateOrWailist: function () {
      // check if in url
      let id = this.$route.query.id;


      let selected = null;
      if (id) {
        id = Number(id);

        //                    console.log("ID2:");
        //                    console.log(id);

        for (let i = 0; i < this.products.length; i++) {
          //                        console.log("PRODUCT - ID: ");
          //                        console.log(this.products[i].id);
          if (this.products[i].id === id) {
            this.model.products.push(this.products[i]);
            selected = true;
            //                            console.log("ID ADDED:");
            //                            console.log(i);
            i = this.products.length;
          }
        }

        if (selected === null) {
          for (let i = 0; i < this.waitlists.length; i++) {
            if (this.waitlists[i].id === id) {
              this.model.waitlists.push(this.waitlists[i]);
              selected = true;
              i = this.waitlists.length;
            }
          }
        }
      }

      if (selected === null) {
        if (this.products.length) {
          this.model.products.push(this.products[0])
        } else {
          this.model.waitlists.push(this.waitlists[0])
        }
      }

      this.updateTotals();

    }
    ,
    changeProduct: function (product) {

      Event.$emit("cart_add_to_cart", product);

      if (this.checkout.extras_json.single) {
        // unselect others
        for (let i = 0; i < this.model.products.length; i++) {
          if (this.model.products[i].id !== product.id) {
            this.model.products.splice(i, 1);
          }
        }
      }

      if (!this.model.products.length) {
        this.model.products.push(product);
      }

      this.updateTotals();
    },
    changeWaitlist: function (product) {

      Event.$emit("cart_add_to_cart", product);
    },

    updateTotals: function () {
      let payments = 1;

      if (this.model.products.length === 0 && this.model.waitlists.lenght === 0) {
        return;
      }
      // @TODO prevent mixing payments

      let total = 0;
      let totalNow = 0;

      for (let i = 0; i < this.model.products.length; i++) {
        total += parseFloat(this.model.products[i].price);
        totalNow += parseFloat(this.model.products[i].price_now);
        payments = this.model.products[i].payments;
      }

      total = total * this.model.quantity;

      let discount = 0;
      // check if checkout has enabled discounts
      if (this.checkout.enable_discounts && this.model.products.length > 1) {
        discount = total * 0.1;
      }

      // deduct discount
      let couponDiscount = 0;
      if (this.model.coupon) {
        couponDiscount = total * this.model.coupon.discount;
      }

      let totalDiscount = discount + couponDiscount;
      let priceWithDiscount = total - totalDiscount;

      let discountPercentage = totalDiscount > 0 ? totalDiscount / total : 0;



      // let price_pay_now = priceWithDiscount / payments;
      let price_pay_now = totalNow * (1 - discountPercentage);

      let price_pay_later = 0;
      if (payments > 1) {
        price_pay_later = priceWithDiscount - price_pay_now
      }


      this.model.price_discount = totalDiscount.toFixed(2);
      this.model.price_total_without_discount = total.toFixed(2);
      this.model.price_total = priceWithDiscount.toFixed(2);
      this.model.price_pay_later = price_pay_later.toFixed(2);
      this.model.price_pay_now = price_pay_now.toFixed(2);
      this.model.payments = payments;


    },

    validateDatesData: function () {
      return true;
    }
    ,
    validateCustomerData: function () {
      this.customValidation.customerData = this.$refs.customerDataForm.validate();
      return this.customValidation.customerData;
    }
    ,
    validatePaymentMethods: function () {
      return this.$refs.paymentMethodsForm.validate();
      //                return this.customValidation.paymentMethods;
    }
    ,


    onChange: function () {
      $('html, body').animate({
        scrollTop: $("#checkout").offset().top
      }, 800);

      this.model = this.model;

      //                this.model.customer.first_name = this.model.customer.first_name + " ";
      this.model.customer.first_name.replace(/\s?$/, '');
    }
    ,


    onComplete: function () {
      Event.$emit("process_payment", "");
      //                this.blockUI = true;
      //
      //                if (this.model.payment_method === "braintree_credit_card" && !this.model.payment_method_nonce) {
      //
      //                    this.$refs.module_payment_methods.instances.hostedFieldsInstance.tokenize(function (err, payload) {
      //                        if (err) {
      ////                            console.error(err);
      ////                                    code:"HOSTED_FIELDS_FIELDS_INVALID"
      ////                                    details: [
      ////                                        invalidFieldKeys:["number"],
      ////                                    message: "Some payment input fields are invalid. Cannot tokenize invalid card fields."
      ////                                    name:"BraintreeError"
      ////                                    type: "CUSTOMER"
      ////                                     ]
      //                            return;
      //                        }
      //
      ////                                binData: {prepaid: "Unknown", healthcare: "Unknown", debit: "Unknown", durbinRegulated: "Unknown", commercial: "Unknown"},
      ////                                description:"ending in 11"
      ////                                details:{lastTwo: "11", lastFour: "1111", cardType: "Visa"}
      ////                                nonce:"71cb0508-bbc1-0759-111a-3a4e7778bdea"
      ////                                type:"CreditCard"
      //
      //
      //                        // call submit again
      //                        this.onComplete();
      //
      //                    }.bind(this));
      //
      //
      //                    return;
      //                }
      //
      //
      //                axios.post(this.submit_url, this.model)
      //                    .then(function (response) {
      //
      //                        if (response.data.success === true) {
      //                            // redirect
      //                            window.location = response.data.url;
      ////                            console.log(response.data);
      ////                            console.log(response.data.url);
      //                        } else {
      //                            // show error
      //                            this.blockUI = false;
      //                            Event.$emit("process_order_error", response);
      //                            this.order_id = response.data.order_id;
      //                        }
      //                    }.bind(this))
      //                    .catch(function (error) {
      //                        this.blockUI = false;
      //                        console.log(error);
      //                    }.bind(this));

    }
    ,


    prettyJSON: function (json) {
      if (json) {
        json = JSON.stringify(json, undefined, 4);
        json = json.replace(/&/g, '&').replace(/</g, '<').replace(/>/g, '>');
        return json.replace(
          /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
          function (match) {
            var cls = 'number';
            if (/^"/.test(match)) {
              if (/:$/.test(match)) {
                cls = 'key';
              } else {
                cls = 'string';
              }
            } else if (/true|false/.test(match)) {
              cls = 'boolean';
            } else if (/null/.test(match)) {
              cls = 'null';
            }
            return '<span class="' + cls + '">' + match + '</span>';
          });
      }
    }
  }
  ,


  computed: {

    isValidForm: function () {
      return this.customValidation.customerData && this.$refs.paymentMethodsForm.validate();
    },

    payment_method: function () {
      return this.model.payment_method;
    }
    ,

    // a computed getter
    displayFirstTab: function () {
      // `this` points to the vm instance
      return (this.waitlists.length + this.products.length) > 1;
    }
    ,
    welcomeText: function () {
      // `this` points to the vm instance
      // if (['spletni_tecaj', 'gzz_posnetek'].includes(this.checkout.type)) {
      if ($.inArray("this.checkout.type", ["spletni_tecaj", "gzz_posnetek"]) > -1) {
        return "Izberite spletno akcijo, na katero bi se radi prijavili";
      } else {
        return "Izberite delavnice na katere bi se radi prijavili.";
      }

    }
    ,
    productTypeName: function () {

      // if (['spletni_tecaj', 'gzz_posnetek'].includes(this.checkout.type)) {
      if ($.inArray("this.checkout.type", ["spletni_tecaj", "gzz_posnetek"]) > -1) {
        return "Spletni Tečaj";
      } else {
        return "Delavnica";
      }
    }
    ,

    multiplePayments: function () {

      for (let i = 0; i < this.model.products.length; i++) {
        if (this.model.products[i].payments > 1) {
          return true;
        }
      }

      return false;

    }
  }
  ,


}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Prijavnica.vue